export default "__VITE_ASSET__CSzpJ6gd__"